export const fades = [
  {
    duration: 0.2,
    from: { alpha: 1 },
    to: { alpha: 0 },
  }, {
    duration: 0.2,
    from: { alpha: 0 },
    to: { alpha: 1 },
  },
]
